import React from "react";
import { useDispatch } from "react-redux";
import MaterialModal from "../MaterialModal";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";

import ImportBulkLogDetail from "./ImportBulkLogDetail";

// Types and Interfaces
type IModalProps = {
    logId: number;
};

type IProps = {
    isOpen: boolean;
    modalProps: IModalProps;
};

const ImportBulkLogDetailModal: React.FC<IProps> = ({ modalProps, isOpen }: IProps) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("IMPORT_BULK_LOG_DETAIL_MODAL"));
    return (
        <MaterialModal
            id="import-bulk-log-detail-modal"
            isOpen={isOpen}
            onClose={hide}
            title={"Import Log Detail"}
            showPrimaryButton={false}
            cancelButtonText="Close"
            fullWidth={true}
        >
            <ImportBulkLogDetail
                key={modalProps.logId}
                id={modalProps.logId}
                //isModal
                //name={modalProps.logId}
            />
        </MaterialModal>
    );
};

export default withModal(ImportBulkLogDetailModal, "IMPORT_BULK_LOG_DETAIL_MODAL");
